import React from 'react';
import { getParkSeoFooterContent } from '../utils/seoShared';

function ParkSeoFooter({ routePath }) {
  const footerContent = getParkSeoFooterContent(routePath);

  if (!footerContent) return null;

  const titleId = `park-seo-footer-${String(routePath || 'home').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'home'}`;

  return (
    <section
      className="park-seo-footer"
      aria-labelledby={titleId}
      lang="fr"
      data-priority={footerContent.priority}
      data-keyword-source={footerContent.keywordSource}
    >
      <div className="park-seo-footer__inner">
        <h2 id={titleId}>{footerContent.footerTitle}</h2>
        {footerContent.footerParagraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}

export default ParkSeoFooter;
